module.exports = __webpack_public_path__ + "img/0040.dc52d481.jpg";